export default __webpack_public_path__ + "static/media/img.7f1036ff.png";